// Un pago parcial genera 2+ filas en tblmultipagos_intenciones: la original
// (que pasa de estatus PARCIAL a PAGADO una vez cubierta) y uno o mas
// "complementos", que guardan id_intencion_origen apuntando a la original.
// Alumnos, ex-alumnos y externos comparten el mismo mecanismo (Mtd_RegistrarComplemento),
// asi que esta funcion se usa desde los historiales de los tres.
//
// Devuelve una funcion que, dado un pago de la lista, contesta:
//   null                    -> pago hecho en un solo registro (nada que resaltar)
//   { folio, numero }       -> folio compartido por el grupo, y el numero de
//                              parcialidad (1 = pago original, 2 = primer
//                              complemento, 3 = segundo complemento, etc.),
//                              calculado por orden de creacion (id ascendente).
export function calcularInfoParcialidad(historialPagos) {
  const idsConComplemento = new Set(
    historialPagos.map((p) => p.id_intencion_origen).filter(Boolean)
  );

  const folioDe = (pago) =>
    pago.id_intencion_origen || (idsConComplemento.has(pago.id) ? pago.id : null);

  const gruposPorFolio = {};
  historialPagos.forEach((p) => {
    const folio = folioDe(p);
    if (folio === null) return;
    if (!gruposPorFolio[folio]) gruposPorFolio[folio] = [];
    gruposPorFolio[folio].push(p);
  });

  return (pago) => {
    const folio = folioDe(pago);
    if (folio === null) return null;
    const ordenado = [...gruposPorFolio[folio]].sort((a, b) => a.id - b.id);
    const numero = ordenado.findIndex((r) => r.id === pago.id) + 1;
    return { folio, numero };
  };
}
